import { createAction, props } from '@ngrx/store';
import { CategoryV2 } from 'thkee-common';

export const CategoryActions = {
  loadCategories: createAction('[Category] Load Categories'),
  loadCategoriesSuccess: createAction('[Category] Load Categories Success', props<{ categories: CategoryV2[] }>()),
};
